import { render, staticRenderFns } from "./CoachInvitationsDialog.vue?vue&type=template&id=58b62a8e&scoped=true"
import script from "./CoachInvitationsDialog.vue?vue&type=script&lang=js"
export * from "./CoachInvitationsDialog.vue?vue&type=script&lang=js"
import style0 from "./CoachInvitationsDialog.vue?vue&type=style&index=0&id=58b62a8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b62a8e",
  null
  
)

export default component.exports